export default {
  state: {
    changeAddOrEditPaymentDialog: false,
  },
  actions: {// 在action中可以进行异步操作，外部用dispatch()调用
    setAddOrEditPaymentDialog ({commit, state}, param) {
      commit('setAddOrEditPaymentDialog', param)
    },
  },
  getters: {// 获取state里面的数据
    changeAddOrEditPaymentDialog (state) {
      return state.changeAddOrEditPaymentDialog
    },
  },
  mutations: {// 不要在mutations里面进行异步操作，外部用commit()调用
    setAddOrEditPaymentDialog (state, action) {
      state.changeAddOrEditPaymentDialog = action
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/financeManage/index.js